import { connect } from "react-redux";
import { XS_MOBILE, SM_MOBILE, MD_TABLET, LG_TABLET } from "../../../../../constants/textConstants";
import { Button, Icon, LinkText } from "../../../index";
import { PageHeading, HeadingButtonCTA, HeadingLangCTA, HeadingPrintCTA } from "../../index";
import './mychart_heading.scss';

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

export const MyChartHeading = connect(mapStateToProps)(({
    bodyOffset,
    className,
    ctaOnly = false,
    description,
    heading,
    headingButton,
    isSubSection, //Subsection of page and does not take up whole page
    printButton,
    proxyName,
    screenBreakPoint,
}) => {

    const isMobile = ([XS_MOBILE, SM_MOBILE, MD_TABLET, LG_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;
    const wrapRightHand = ([XS_MOBILE, SM_MOBILE, MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;

    const myChartHeadingClasses = [
        `mybswh-mychart-heading`,
        `${ctaOnly ? 'mybswh-mychart-heading__cta-only' : ''}`,
        `${isSubSection ? 'mybswh-mychart-heading__subsection' : ''}`,
        `${className ? className : ''}`
    ].join(' ');

    const printLangCTA = <div className="mybswh-mychart-heading__page-cta">
        {printButton && !isMobile &&
            <HeadingPrintCTA
                onClick={printButton?.onClick}
                to={printButton?.to}
            />
        }
        <HeadingLangCTA />
    </div>;

    const rightHandSection = <>
        {headingButton &&
            <HeadingButtonCTA
                label={headingButton?.label}
                onClick={headingButton?.onClick}
                to={headingButton?.to}
            />
        }
        {!wrapRightHand && 
            printLangCTA
        }
    </>;

    return ( ctaOnly
            ? <div className={myChartHeadingClasses}>
                {wrapRightHand && printLangCTA}
                {rightHandSection}
              </div>
            : <>
                {wrapRightHand && printLangCTA}
                <PageHeading
                    bodyOffset={bodyOffset}
                    className={myChartHeadingClasses}
                    heading={heading}
                    description={description}
                    proxyName={proxyName}
                    righthand={rightHandSection}
                />
            </>
    )
})